import { create } from "zustand";

export type ToastVariant = "info" | "success" | "error";

export interface ToastEntry {
  id: string;
  message: string;
  variant: ToastVariant;
}

interface UiState {
  toasts: ToastEntry[];
  isCoachOpen: boolean;
  isPhoneSheetOpen: boolean;

  pushToast: (message: string, variant?: ToastVariant) => void;
  dismissToast: (id: string) => void;
  setCoachOpen: (open: boolean) => void;
  setPhoneSheetOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  toasts: [],
  isCoachOpen: false,
  isPhoneSheetOpen: false,

  pushToast: (message, variant = "info") => {
    const id = `t-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    set((state) => ({ toasts: [...state.toasts, { id, message, variant }] }));
    setTimeout(() => {
      set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
    }, 3500);
  },
  dismissToast: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
  setCoachOpen: (isCoachOpen) => set({ isCoachOpen }),
  setPhoneSheetOpen: (isPhoneSheetOpen) => set({ isPhoneSheetOpen }),
}));
